import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { provide, ref } from 'vue';

import DocumentCollection from 'SharedComponents/Documents/DocumentCollection.vue';
import Explorer from 'SharedComponents/Documents/Explorer.vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { ServiceKey } from 'SharedDir/constants/file-system';
import CommonFileSystem from 'SharedDir/service/file/CommonFileSystem';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'WrapperDocuments' },
  __name: 'WrapperDocuments',
  props: {
    modelValue: {},
    proMode: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    compact: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {


const props = __props;

const emits = __emit;
const { innerValue, emitValue } = useValue(props, emits);
const refExplorer = ref<typeof Explorer>();

function refresh() {
  return refExplorer.value?.refresh();
}

__expose({ refresh });

provide(ServiceKey, new CommonFileSystem());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["full-width", { 'base-padding': !_ctx.compact }]),
    style: _normalizeStyle(_ctx.compact ? undefined : { minHeight: '300px' })
  }, [
    _createVNode(Explorer, {
      ref_key: "refExplorer",
      ref: refExplorer,
      root: _unref(innerValue),
      "pro-mode": _ctx.proMode,
      readonly: _ctx.readonly
    }, {
      documents: _withCtx(({ view, directory }) => [
        (directory && directory.documents.length > 0)
          ? (_openBlock(), _createBlock(DocumentCollection, {
              key: 0,
              view: view,
              class: "document",
              data: directory.documents,
              "folder-id": directory.id,
              "root-folder-id": Number(_unref(innerValue)),
              "folder-entity": directory.entity,
              "folder-entity-id": directory.entityId,
              readonly: directory.isReadonly || _ctx.readonly,
              onChanged: refresh
            }, null, 8, ["view", "data", "folder-id", "root-folder-id", "folder-entity", "folder-entity-id", "readonly"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["root", "pro-mode", "readonly"])
  ], 6))
}
}

})